import { useContactModal } from "@/context/ContactModalContext";

const CTABanner = ({
  text = "Clear, structured advice starts with the right conversation.",
}) => {
  const { open } = useContactModal();
  return (
    <section data-testid="cta-banner" className="relative bg-[#0C0C0C]">
      <div className="h-px bg-gradient-to-r from-transparent via-[#C6A96B]/55 to-transparent" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-7 md:py-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-5">
        <p className="font-serif text-[23px] md:text-[28px] leading-snug text-gold italic">
          {text}
        </p>
        <button
          onClick={open}
          data-testid="cta-banner-button"
          className="shrink-0 px-6 py-2.5 bg-black/20 border border-[#D8BD7A] text-[13px] font-medium tracking-[0.04em] text-[#D8BD7A] backdrop-blur-sm hover:bg-gold hover:border-gold hover:text-[#0A0A0A] transition-all duration-200"
        >
          Start a conversation
        </button>
      </div>
    </section>
  );
};

export default CTABanner;
